import { render, staticRenderFns } from "./olvida_contra.vue?vue&type=template&id=5686b6a2"
import script from "./olvida_contra.vue?vue&type=script&lang=js"
export * from "./olvida_contra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports